import "./index.css";

import React from "react";
import ReactDOM from "react-dom/client";
import ReactGA from "react-ga4";

import App from "./App";
import Keys from "./constants/Keys";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.querySelector("#root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

if (Keys.GoogleAnalytics == true) {
  ReactGA.initialize(Keys.GoogleAnalyticsKey);
  const SendAnalytics = () => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
    });
  };
  reportWebVitals(SendAnalytics);
} else {
  reportWebVitals();
}
